<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title class="headline">
        Edytuj przekierowanie
      </v-card-title>
      <v-card-text>
        <v-form
            ref="newForm"
            v-model="valid"
            lazy-validation
            class="dimension--form mt-5 mb-5"
        >
          <v-row>
            <v-col cols="12" md="12" align-self="start" dense>
              <v-text-field
                  v-model="redirect.from"
                  :rules="formRules.from"
                  class="pt-0"
                  type="url"
                  label="Adres źródłowy"
              ></v-text-field>
              <v-text-field
                  v-model="redirect.to"
                  :rules="formRules.to"
                  class="pt-0"
                  type="url"
                  label="Adres docelowy"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                @click.prevent="onSubmit"
                type="Submit"
                class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                large
            >Zapisz&nbsp;<v-icon size="24">mdi-send</v-icon>
            </v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalEditRedirect',
  props: {
    item: {},
  },
  created() {
  },
  data() {
    return {
      dialog: false,
      form: {
        from: '',
        to: '',
      },
      formRules: {
        from: [(value) => !!value || 'Wpisz adres źródłowy'],
        to: [(value) => !!value || 'Wpisz adres docelowy'],
      },
      valid: false,
      redirect: {
        from: '',
        to: '',
      },
    }
  },
  methods: {
    open(redirect) {
      this.redirect = redirect;
      this.dialog = true
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const redirect = {
        from: this.redirect.from,
        to: this.redirect.to,
      }
      api
          .put('/api/redirects/' + this.redirect.id, redirect)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Przekierowanie zostało zaktualizowane.',
            });
            this.dialog = false;
          })
          .catch((error) => {
            console.error('Error when editing a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
